<template>
  <input
    class="native-datetime-input"
    type="datetime-local"
    lang="en-GB"
    step="1"
    :value="formattedValue"
    :disabled="disabled"
    :aria-label="ariaLabel"
    @input="handleInput"
  />
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Date,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  ariaLabel: {
    type: String,
    default: 'Timestamp',
  },
});

const emit = defineEmits(['update:modelValue']);

const pad = value => String(value).padStart(2, '0');

const formattedValue = computed(() => {
  const value = props.modelValue;
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) return '';

  return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`
    + `T${pad(value.getHours())}:${pad(value.getMinutes())}:${pad(value.getSeconds())}`;
});

function handleInput(event) {
  const match = event.target.value.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/
  );
  if (!match) return;

  const [, year, month, day, hour, minute, second = '0'] = match;
  const value = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
    0
  );
  if (!Number.isNaN(value.getTime())) emit('update:modelValue', value);
}
</script>

<style scoped>
.native-datetime-input {
  width: 100%;
  padding: 0.45rem 0.5rem;
  color-scheme: dark;
}

.native-datetime-input:disabled {
  cursor: default;
}
</style>
